
const validate = (values) => {
  const errors = {};
  if (!values.MasterEDIGatewayID) {
    errors.MasterEDIGatewayID = 'Please select clearing house name';
  }
  if (!values.senderID) {
    errors.senderID = 'Please enter sender id';
  }
  if (!values.receiverID) {
    errors.receiverID = 'Please enter receiver id';
  }
  if (!values.interchangeQualifier) {
    errors.interchangeQualifier = 'Please enter interchange qualifier';
  }
  if (!values.ftpurl) {
    errors.ftpurl = 'Please enter ftp url';
  }
  if (!values.portNo) {
    errors.portNo = 'Please enter ftp port';
  }


  // if (!values.FTPUsername) {
  //   errors.FTPUsername = 'Please enter ftp username';
  // }
  // if (!values.FTPPassword) {
  //   errors.FTPPassword = 'Please enter ftp password';
  // }

  if (!values.ftpUsername || values.ftpUsername.trim() === '') {
    errors.ftpUsername = 'Please enter username';
  }
  if (values.ftpUsername) {
    if (values.ftpUsername.trim().length < 3) {
      errors.ftpUsername = 'Please enter minimum 3 characters';
    }
  }
  if (!values.ftpPassword || values.ftpPassword.trim() === '') {
    errors.ftpPassword = 'Please enter password';
  }
  if (values.ftpPassword) {
    if (values.ftpPassword.trim().length < 8) {
      errors.ftpPassword = 'Please enter minimum 8 characters';
    }
  }
  if (!values.ftpConfirmPassword || values.ftpConfirmPassword.trim() === '') {
    errors.ftpConfirmPassword = 'Please enter confirm password';
  }
  if (values.ftpConfirmPassword && values.ftpPassword && values.ftpConfirmPassword !== values.ftpPassword) {
    errors.ftpConfirmPassword = 'Password doesn\'t match';
  }

  if (!values.path837) {
    errors.path837 = 'Please enter path for 837 folder';
  }
  if (!values.path835) {
    errors.path835 = 'Please enter path for 835 folder';
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/clearing-house/new-validate.js